import { defineMessages } from 'react-intl';

export default defineMessages({
  footerPublicCopyright: {
    defaultMessage: '© 2016-{yearTo} 2N Telekomunikace a.s. All rights reserved.',
    id: 'footerPublic.copyright',
  },
  marketingMessageButtonLabel: {
    defaultMessage: 'Vote here',
    id: 'marketingMessage.buttonLabel',
  },
  marketingMessageSubtitle: {
    defaultMessage: 'Suggest new features or support ideas already shared by the My2N community.',
    id: 'marketingMessage.subtitle',
  },
  marketingMessageTitle: {
    defaultMessage: 'Influence the Future of My2N',
    id: 'marketingMessage.title',
  },
});
